import { render, staticRenderFns } from "./AccountVerification.vue?vue&type=template&id=65875606&scoped=true&"
import script from "./AccountVerification.vue?vue&type=script&lang=js&"
export * from "./AccountVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65875606",
  null
  
)

export default component.exports